import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Card, Stack, Container, Typography, Button } from '@mui/material';
import Page from '../../components/Page';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

const ContentStyle = styled(Card)(({ theme }) => ({
  maxWidth: 520,
  margin: 'auto',
  padding: theme.spacing(5),
  textAlign: 'center',
}));

export default function InvestorPendingApproval() {
  return (
    <RootStyle title="Pending Approval | Gateway X Syndication">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack spacing={3} alignItems="center">
            <HourglassEmptyIcon sx={{ fontSize: 64, color: 'warning.main' }} />
            <Typography variant="h4">Registration Under Review</Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Thank you for registering with Gateway X Syndication. Your application is currently
              being reviewed by our team.
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600 }}>
              This process typically takes up to 24 hours.
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You will receive an email once your account has been approved. After approval,
              you will be guided to set up two-factor authentication before accessing the platform.
            </Typography>
            <Button
              variant="outlined"
              component={RouterLink}
              to="/investor/login"
              sx={{ mt: 2 }}
            >
              Back to Login
            </Button>
          </Stack>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
